"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpectedApiResponse = void 0;
const ExpectedApiResponses_1 = require("./ExpectedApiResponses");
const isExpectedApiResponse = ({ apiUrl, apiStatus, apiResponse, }) => {
    const apiUrlLowercase = apiUrl.toLowerCase();
    return ExpectedApiResponses_1.expectedApiErrors.some((exception) => {
        // Find matching apiUrl & apiStatus
        if (apiUrlLowercase.includes(exception.api.toLowerCase()) &&
            apiStatus === exception.code) {
            // Handle empty api response with filter on all messages
            if (exception.messages.length === 0 && apiResponse === "") {
                return true;
            }
            // Find matching apiResponse
            return exception.messages.some((msg) => {
                if (apiResponse.includes(msg)) {
                    return true;
                }
            });
        }
    });
};
exports.isExpectedApiResponse = isExpectedApiResponse;
//# sourceMappingURL=ErrorFiltering.js.map